// client/src/components/stats/vpipBenchmarks.ts
//
// Rangos saludables de VPIP por posición para MTT 6-max (theoretical, solver-based).
// BB SÍ se incluye porque tiene oportunidad clara de VPIP: defend vs steal, float, etc.
// Rangos más amplios que RFI porque VPIP incluye calls — hay más varianza de meta/stake.

import { Position } from '../../utils/pokerStats/types';

export interface VpipBenchmark {
  min: number;
  max: number;
}

// Posiciones que tienen benchmark de VPIP (todas excepto OTHER)
export type VpipPosition = 'EP' | 'HJ' | 'CO' | 'BTN' | 'SB' | 'BB';

export const VPIP_BENCHMARKS: Record<VpipPosition, VpipBenchmark> = {
  EP:  { min: 12, max: 18 },
  HJ:  { min: 15, max: 22 },
  CO:  { min: 20, max: 28 },
  BTN: { min: 28, max: 38 },
  SB:  { min: 30, max: 42 },
  BB:  { min: 22, max: 32 },
};

export type VpipStatus = 'ok' | 'warn' | 'critical';

export function evalVpip(position: Position, value: number): VpipStatus {
  const r = VPIP_BENCHMARKS[position as VpipPosition];
  if (!r) return 'ok';
  if (value >= r.min && value <= r.max) return 'ok';
  const gap = value > r.max ? value - r.max : r.min - value;
  const range = r.max - r.min || 5;
  return gap > range * 1.5 ? 'critical' : 'warn';
}

export function getVpipBenchmark(position: Position): VpipBenchmark | null {
  return VPIP_BENCHMARKS[position as VpipPosition] || null;
}
